/* eslint-disable no-param-reassign */
/**
 * Created by zad on 17/10/18.
 */
import Immutable, { fromJS } from 'immutable';
import Cookies from 'js-cookie';
import { Global } from '../../constants/actionTypes';
import { isDev } from '../../utils/util';

const locale = Cookies.get('locale') || 'zh-CN';
const readMode = Cookies.get('read_mode') || 'day';
const fontType = Cookies.get('default_font') || 'font2';

const initialState = {
  locale, // 地区
  readMode, // 浏览模式
  fontType, // font1 -> 宋体 font2 -> 黑体
  isDev,
  bindStatus: true,
  account: {},
  occupyhasother: {
    status: false,
    msg: '',
  },
  noOtherAccount: {
    status: false,
    msg: '',
    step: 1,
    data: '{}',
  },
  bindWx: true,
  bindPhoneStatus: true, // 是否已绑定手机，默认是true
  // 文章发布成功的全局控制数据
  publishSuccessModalData: {
    show: false, // 是否展示发布成功的modal
    data: {}, // 存有noteId isPaid字段
  },
  // 显示微信二维码
  qrCodeModal: {
    show: false,
    data: {},
  },
  // 一些关于note的共享信息
  noteData: {
    isInit: false, // 是否是新建文章
  },
  // 显示付费文章协议弹窗
  pnAgreeModal: {
    show: false,
    data: {},
  },
  // 正在移动文章的数据
  sortingNote: {
    isSorting: false,
    isCursorOnNbItem: false, // 鼠标是否在文集item上
    noteId: null,
    nbId: null,
    newNbId: null,
  },
  // 购买定时发文的modal
  timePublishBuyModal: {
    visible: false,
    data: {},
  },
};

export default function (state = Immutable.fromJS(initialState), action) {
  switch (action.type) {
    case Global.CHANGE_LOCALE: {
      return state;
    }
    case Global.CHANGE_LOCALE_SUCCESS: {
      state = state.setIn(['locale'], action.locale);
      return state;
    }
    case Global.CHANGE_LOCALE_FAIL: {
      return state;
    }
    case Global.CHANGE_READ_MODE: {
      return state;
    }
    case Global.CHANGE_READ_MODE_SUCCESS: {
      state = state.setIn(['readMode'], action.readMode);
      return state;
    }
    case Global.CHANGE_READ_MODE_FAIL: {
      return state;
    }
    case Global.CHANGE_FONT_TYPE: {
      return state;
    }
    case Global.CHANGE_FONT_TYPE_SUCCESS: {
      state = state.setIn(['fontType'], action.fontType);
      return state;
    }
    case Global.CHANGE_FONT_TYPE_FAIL: {
      return state;
    }
    case Global.SET_BIND_WX_STATUS: {
      const { status } = action;
      state = state.setIn(['bindWx'], status);
      return state;
    }
    case Global.SET_BIND_PHONE_STATUS: {
      const { hasBind } = action;
      state = state.setIn(['bindPhoneStatus'], hasBind);
      return state;
    }
    case Global.SET_BIND_STATUS: {
      const { data, status } = action;
      state = state.setIn(['bindStatus'], status);
      if (data) {
        state = state.setIn(['account'], data);
      }
      return state;
    }
    case Global.SET_PUBLISH_SUCCESS_MODAL_DATA: {
      const { show, data = {} } = action;
      state = state.setIn(['publishSuccessModalData'], Immutable.fromJS({ show, data }));
      return state;
    }
    case Global.SET_QRCODE_MODAL_DATA: {
      const { data = {}, show } = action;
      state = state.setIn(['qrCodeModal'], Immutable.fromJS({ show, data }));
      return state;
    }
    case Global.SWITCH_DEV: {
      state = state.setIn(['isDev'], !state.get('isDev'));
      return state;
    }
    case Global.SET_NOTE_DATA: {
      const { data = {} } = action;
      state = state.setIn(['noteData', 'isInit'], data.isInit);
      return state;
    }
    case Global.SET_SORTED_NOTE_DATA: {
      const { data = {} } = action;
      state = state.setIn(['sortingNote'], Immutable.fromJS(data));
      return state;
    }
    case Global.SET_PNAGREE_MODAL_DATA: {
      const { show, data = {} } = action;
      state = state.setIn(['pnAgreeModal'], Immutable.fromJS({
        show,
        data,
      }));
      return state;
    }
    case Global.SET_OCCUPY_HASOTHER: {
      const { msg, status } = action;
      state = state.setIn(['occupyhasother'], {
        status,
        msg,
      });
      return state;
    }
    case Global.SET_OCCUPY_NOOTHER: {
      const { msg, status, step, data } = action;
      state = state.setIn(['noOtherAccount'], {
        status,
        msg,
        step,
        data,
      });
      return state;
    }
    case Global.OPEN_TIME_PUBLISH_BUY_MODAL: {
      const { data } = action;
      state = state.setIn(['timePublishBuyModal', 'data'], fromJS(data));
      state = state.setIn(['timePublishBuyModal', 'visible'], true);
      return state;
    }
    case Global.CLOSE_TIME_PUBLISH_BUY_MODAL: {
      state = state.setIn(['timePublishBuyModal', 'visible'], false);
      return state;
    }
    default:
      return state;
  }
}

export const getState = state => state.Global;




// WEBPACK FOOTER //
// ./src/reducers/Global/GlobalReducer.js